import "./ClassificationSection.css";

const categories = [
  "Breakfast",
  "Lunch",
  "Dinner",
  "Snacks",
  "Bakery",
  "Beverages",
  "Desserts",
  "Rice",
  "Biryani",
  "South Indian",
  "North Indian",
  "Chinese",
  "Fast Food",
  "Healthy",
  "Festival Specials",
];

const menuItemTypes = [
  "Food",
  "Beverage",
  "Dessert",
  "Bakery Item",
  "Combo Meal",
  "Catering Package",
];

const dietTypes = [
  "Veg",
  "Non-Veg",
  "Egg",
  "Vegan",
  "Jain",
];

function ClassificationSection({
  formData,
  updateField,
}) {
  return (
    <div className="food-form-section">

      <h3 className="section-title">
        Classification
      </h3>

      <div className="classification-grid">

        {/* Category */}

        <div className="form-group">

          <label>
            Category *
          </label>

          <select
            value={formData.category}
            onChange={(e) =>
              updateField(
                "category",
                e.target.value
              )
            }
          >
            <option value="">
              Select Category
            </option>

            {categories.map((category) => (
              <option
                key={category}
                value={category}
              >
                {category}
              </option>
            ))}

          </select>

        </div>

        {/* Sub Category */}

        <div className="form-group">

          <label>
            Sub Category
          </label>

          <input
            type="text"
            placeholder="Example: Dosa"
            value={formData.subCategory}
            onChange={(e) =>
              updateField(
                "subCategory",
                e.target.value
              )
            }
          />

        </div>

        {/* Menu Item Type */}

        <div className="form-group">

          <label>
            Menu Item Type
          </label>

          <select
            value={formData.menuItemType}
            onChange={(e) =>
              updateField(
                "menuItemType",
                e.target.value
              )
            }
          >
            {menuItemTypes.map((type) => (
              <option
                key={type}
                value={type}
              >
                {type}
              </option>
            ))}
          </select>

        </div>

        {/* Diet Type */}

        <div className="form-group">

          <label>
            Diet Type
          </label>

          <select
            value={formData.dietType}
            onChange={(e) =>
              updateField(
                "dietType",
                e.target.value
              )
            }
          >
            {dietTypes.map((diet) => (
              <option
                key={diet}
                value={diet}
              >
                {diet}
              </option>
            ))}
          </select>

        </div>

      </div>

    </div>
  );
}

export default ClassificationSection;